var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Theme, { logoCivitrip, marks, strMark } from 'Theme';
import UserLogin from 'modules/Users/containers/UserLogin';
import { Logo } from 'components';
import { Label } from 'reactstrap';
import { inject } from 'mobx-react';
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Login.prototype.render = function () {
        var _a;
        var src = '/logo_ticando.svg';
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        if (isCivitrip) {
            src = logoCivitrip;
        }
        return (React.createElement(Wrapper, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '60px',
                    paddingLeft: '60px',
                    paddingRight: '60px',
                    width: '100%'
                } },
                React.createElement("img", { src: src, height: isCivitrip ? '35px' : '50px', width: '220px', alt: 'img ticando' })),
            React.createElement(Label, { style: {
                    marginBottom: 0,
                    color: Theme.color.hairline,
                    width: '100%',
                    textAlign: 'center',
                    paddingTop: Theme.size.space[1]
                } }, "".concat(process.env.REACT_APP_VERSION)),
            React.createElement(Label, { size: '10', style: {
                    marginTop: 0,
                    color: Theme.color.hairline,
                    width: '100%',
                    textAlign: 'center',
                    paddingTop: Theme.size.space[1]
                } }, "".concat(process.env.REACT_APP_DATEBUILD)),
            React.createElement(UserLogin, { queryParams: this.props.queryParams })));
    };
    Login = __decorate([
        inject('store')
    ], Login);
    return Login;
}(Component));
export default Login;
var Wrapper = cxs('div')({
    boxShadow: "0 0 100px -20px ".concat(opacity(0.25, Theme.color.primary)),
    margin: 'auto',
    borderWidth: "".concat(Theme.size.hairline),
    borderColor: Theme.color.hairline,
    borderStyle: 'solid'
});
var StyledLogo = cxs(Logo)({
    margin: "".concat(Theme.size.space[4], " ").concat(Theme.size.space[4], " 0 ").concat(Theme.size
        .space[4])
});



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Login.tsx
// module id = 1618
// module chunks = 0